import { ColumnData } from '../types/column.types';

// 200px estimated padding and index - This is still hardcoded at 12 column minsize which is not ideal
const SIZE = (window.innerWidth - 200) / 12;
const MIN_SIZE = 100;

export const ALL_EXPOSURE_COLUMNS: ColumnData[] = [
  {
    id: 'name',
    title: 'Asset Name',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: 300,
    minSize: MIN_SIZE,
  },
  {
    id: 'isin',
    title: 'ISIN',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'instrument_title',
    title: 'Instrument Title',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'instrument_description_title',
    title: 'Instrument Description',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'asset_class',
    title: 'Asset Class',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'asset_type',
    title: 'Asset Type',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'currency',
    title: 'Currency',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },

  {
    id: 'fx',
    title: 'FX Rate',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'lc_exposure',
    title: 'Local Exposure',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'lc_exposure_pct',
    title: 'Local Exposure %',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'bc_exposure',
    title: 'Base Exposure',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'bc_exposure_pct',
    title: 'Base Exposure %',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'gross_exposure',
    title: 'Gross Exposure',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'gross_exposure_pct',
    title: 'Gross Exposure %',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'commitment',
    title: 'Commitment',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'commitment_pct',
    title: 'Commitment %',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  // {
  //   title: 'Notes',
  //   id: 'notes',
  //   show: false,
  // },
  {
    id: 'aml_exposure',
    title: 'AML Exposure',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'country_code_risk_level',
    title: 'Country Code Risk Level',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'country_code',
    title: 'Country Code',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'client_price',
    title: 'Client Price',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'delta',
    title: 'Delta',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'credit_rating',
    title: 'Credit Rating',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'credit_type',
    title: 'Credit Type',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'da_son_exposure',
    title: 'DA SON Exposure',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'days_to_maturity',
    title: 'Days To Maturity',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  // {
  //   id: 'g_name',
  //   title: 'G Name',
  //   show: false,
  //   filterFn: 'inNumberRange',
  //   filterVariant: 'inNumberRange',
  // },
  {
    id: 'icb_sector_name',
    title: 'ICB Sector Name',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'is_listed',
    title: 'Is Listed',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'asset_form',
    title: 'Asset Form',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'cis',
    title: 'Is Collective Investment Scheme (CIS)',
    short_title: 'CIS',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  // {
  //   title: 'Currency Code',
  //   id: 'currency_code',
  //   show: false
  // },
  // {
  //   title: 'G Key',
  //   id: 'g_key',
  //   show: false
  // },
  // {
  //   title: 'GM Id New',
  //   id: 'gm_id_new',
  //   show: false
  // },
  {
    id: 'icb_sector_id',
    title: 'ICB Sector ID',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'is_cb',
    title: 'Is Convertible Bond',
    short_title: 'CB',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'is_cds',
    title: 'Is Credit Default Swap (CDS)',
    short_title: 'CDS',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'is_etf',
    title: 'Is Exchange Traded Fund (ETF)',
    short_title: 'ETF',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'is_loan',
    title: 'Is Loan',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'is_sfi',
    title: 'Is Structured Financial Instrument (SFI)',
    short_title: 'SFI',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'maturity_date',
    title: 'Maturity Date',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'msci_sector_code',
    title: 'MSCI Sector Code',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'msci_sector_name',
    title: 'MSCI Sector Name',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'msci_sector_id',
    title: 'MSCI Sector ID',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },

  {
    id: 'notional_amount',
    title: 'Notional Amount',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'portfolio_id_name',
    title: 'Portfolio ID Name',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'price',
    title: 'Price',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'sum_of_notionals',
    title: 'Sum Of Notionals',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'sector_name',
    title: 'Sector Name',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'sector_id',
    title: 'Sector ID',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'total_issue_size',
    title: 'Total Issue Size',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'unrealised_pl',
    title: 'Unrealised P/L',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'interest_rate',
    title: 'Interest Rate',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  // {
  //   id: 'interest_type',
  //   title: 'Interest Type',
  //   show: false,
  //   filterVariant: 'select',
  //   filterFn: 'arrIncludesSome',
  // },
  {
    id: 'time_to_maturity',
    title: 'Time To Maturity',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  // {
  //   id: 'asset_cs01',
  //   title: 'Asset CS01',
  //   show: false,
  //   filterFn: 'inNumberRange',
  //   filterVariant: 'inNumberRange',
  // },
  // {
  //   id: 'asset_dv01',
  //   title: 'Asset DV01',
  //   show: false,
  //   filterFn: 'inNumberRange',
  //   filterVariant: 'inNumberRange',
  // },
  {
    id: 'cs01',
    title: 'CS01',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'dv01',
    title: 'DV01',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'yield',
    title: 'Yield',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'risk_factor',
    title: 'Risk Factor',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'outstanding_securities',
    title: 'Outstanding Securities',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'coupon',
    title: 'Coupon',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'duration',
    title: 'Duration',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'counterparty_names',
    title: 'Counterparties',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'is_coco',
    title: 'Is Contingent Convertible',
    short_title: 'CoCo',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'is_at1',
    title: 'Is Additional Tier 1',
    short_title: 'AT1',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
];
